
import { useMemo } from 'react'
import Select from '../../../../CommonComponents/select/Select'
import useSelectedGroupSatellite from '../../hooks/useSelectedGroupSatellite'
import './MultiselectGroup.scss'
import useLoader from '../../hooks/useLoader'
import useScenarioResponse from '../../hooks/useScenarioResponse'
import CustomToolTip from '../../../../CommonComponents/CustomToolTip'
import { SatelliteDetails } from '../../../types'
import useAssets from '../../hooks/useAssets'
import useOrbitAnimationDetails from '../../hooks/useOrbitAnimationDetails'

const MultiselectGroup = () => {
    const { presim } = useAssets()
    const { loading } = useLoader()
    const { scenarioResponse } = useScenarioResponse()
    const { orbitAnimationDetails } = useOrbitAnimationDetails()
    const { selectedGroupSatellite, onSelectGroup, onSelectSatellite } = useSelectedGroupSatellite()

    const baseLoader = useMemo(() => loading.base || loading.execution ? true : false, [loading])

    const selectedGroup = useMemo(() => selectedGroupSatellite?.groupId || null, [selectedGroupSatellite?.groupId])
    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId || null, [selectedGroupSatellite?.satelliteId])

    const groups = useMemo(() => scenarioResponse?.satelliteGroups || [], [scenarioResponse?.satelliteGroups])
    const satellites = useMemo(() => groups.find(gp => gp.satelliteGroupId === selectedGroup)?.satellites || [], [groups, selectedGroup])

    const selectedGroupName = useMemo(() => groups.find(gp => gp.satelliteGroupId === selectedGroup)?.satelliteGroupName || '', [groups, selectedGroup])
    const selectedSatelliteName = useMemo(() => satellites.find(sat => sat.satelliteId === selectedSatellite)?.satelliteName || '', [satellites, selectedSatellite])

    //// presim ////
    const presimData = useMemo(() => presim?.data || {}, [presim?.data])
    const selectedPresimData = useMemo(() => presimData?.[selectedSatellite || ''], [presimData, selectedSatellite])
    const showRunningLoader = useMemo(() => selectedPresimData?.status === 'running', [selectedPresimData])
    const animationRunning = useMemo(() => orbitAnimationDetails.startAnimation, [orbitAnimationDetails.startAnimation])

    const disabledGroup = useMemo(() => (animationRunning || baseLoader || groups?.length < 2) ? true : false, [animationRunning, baseLoader, groups])
    const disabledSatellite = useMemo(() => (animationRunning || baseLoader || satellites?.length < 2) ? true : false, [animationRunning, baseLoader, satellites])

    const getPresimState = (satelliteId: string) => {
        const selectedPresimData = presimData[satelliteId]
        if (!selectedPresimData) return ''
        const presimStatus = selectedPresimData.status
        return presimStatus
    }

    const onGroupSelect = (groupId: string) => {
        const selectedGroups = groups.find(g => g.satelliteGroupId === groupId)
        if (!selectedGroups) return
        onSelectGroup(selectedGroups)
    }

    return (
        <div className='multiselect__group__container'>
            <Select id={1} placement="top" value={selectedGroup} onSelect={(value) => { onGroupSelect(value) }}>
                <CustomToolTip title={selectedGroupName} placement='bottom-start'>
                    <Select.Trigger className='multi__select__trigger' disabled={disabledGroup}>
                        <Select.Value placeholder="Select a group" value={selectedGroupName} />
                    </Select.Trigger>
                </CustomToolTip>
                <Select.Content>
                    <Select.Group>
                        {groups.map((group) => (
                            <CustomToolTip key={group?.satelliteGroupId} title={group?.satelliteGroupName} placement='right'>
                                <Select.Item key={group?.satelliteGroupId} value={group.satelliteGroupId}>
                                    {group?.satelliteGroupName}
                                </Select.Item>
                            </CustomToolTip>
                        ))}
                    </Select.Group>
                </Select.Content>
            </Select>

            <Select id={2} placement="top" value={selectedSatellite} onSelect={(value) => { onSelectSatellite(value) }}>
                <CustomToolTip title={selectedSatelliteName} placement='bottom-start'>
                    <Select.Trigger className='multi__select__trigger' loading={showRunningLoader} disabled={disabledSatellite}>
                        <Select.Value placeholder="Select a satellite" value={selectedSatelliteName} />
                    </Select.Trigger>
                </CustomToolTip>
                <Select.Content>
                    <Select.Group>
                        {satellites.map((satellite: SatelliteDetails) => {
                            const presimState = getPresimState(satellite?.satelliteId)
                            return (
                                <CustomToolTip key={satellite?.satelliteId} title={satellite?.satelliteName} placement='right'>
                                    <Select.Item key={satellite?.satelliteId} value={satellite?.satelliteId}>
                                        <div className='multi__select__option__container'>
                                            <span className='select__option__text'>{satellite?.satelliteName}</span>
                                            <div className='select__option__icon__container'>
                                                {presimState === 'running' && <div className='presim__loader' />}
                                                {presimState === 'completed' &&
                                                    <div className='prediction__badge'>
                                                        <span className='badge__text'>PS</span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </Select.Item>
                                </CustomToolTip>
                            )
                        })}
                    </Select.Group>
                </Select.Content>
            </Select>

        </div>
    )
}

export default MultiselectGroup